/**
 * Lightweight PostHog wrapper. PostHog is loaded via /app/frontend/public/index.html.
 * Captures only after explicit cookie consent (accept_all). Otherwise no-ops.
 */
const CONSENT_KEY = "bl_cookie_consent_v1";

function consented() {
    try {
        return localStorage.getItem(CONSENT_KEY) === "accept_all";
    } catch {
        return false;
    }
}

export function track(event, props) {
    if (!consented()) return;
    try {
        if (typeof window !== "undefined" && window.posthog?.capture) {
            window.posthog.capture(event, props || {});
        }
    } catch { /* non-critical */ }
}

export function identify(user) {
    if (!consented() || !user) return;
    try {
        if (typeof window !== "undefined" && window.posthog?.identify) {
            window.posthog.identify(user.user_id, {
                email: user.email,
                name: user.name,
                persona: user.persona,
            });
        }
    } catch { /* non-critical */ }
}

export function reset() {
    try {
        if (typeof window !== "undefined" && window.posthog?.reset) {
            window.posthog.reset();
        }
    } catch { /* non-critical */ }
}
